import { useEffect, useState, useContext } from "react";
import { Form, message } from "antd";
import { useHistory } from "react-router-dom";
import useHttpClient from 'shared/hooks/http-hook';
import { AuthContext } from 'shared/context/auth-context';
import  EndPoints from 'shared/endPoints/EndPoints.json'
import PackingForm from "../PackingForm";
import { usePackage } from "../package-context";

export default function UpdateParcel() {
    const { sendRequest, responseData, requestIdentifier, responseMessage, status, loading } = useHttpClient();
    const { UserId } = useContext(AuthContext);
    const {
        carrierCompany,
         capacity,
        deviceType,
         deviceTypeId,
         carrierCompanyId,
         remainingCapacity,
        barcodePrint,
        isNew,
        parcelId,
        useNewSIM,
    } = usePackage()
    const history = useHistory()
    const [form] = Form.useForm();
    const [isNewOnChangeValue, setIsNewOnChangeValue] = useState(!isNew)

    const handleIsNewChanged = () => {
        setIsNewOnChangeValue(!isNewOnChangeValue)
    }

    useEffect(() => {
        form.setFieldsValue({
            capacity,
            deviceType:  deviceTypeId,
            carrierCompany:  carrierCompanyId,
            remainingCapacity,
            barcodePrint,
            isNew: !isNew,
            useNewSIM,
        })
    }, [ capacity,
         deviceTypeId,
         carrierCompanyId,
         remainingCapacity,
        barcodePrint,
        isNew,
        useNewSIM,
        form
    ])

    useEffect(() => {
        if (status === 'resolved' && requestIdentifier === 'PUTPARCEL') {
            message.success(responseMessage, 2.5)
               
        }
    }, [responseData, requestIdentifier, history, responseMessage, status])

    useEffect(() => {
        if (status === 'rejected') {
            let result;
            Object.keys(responseData).forEach((key) => {
                result = responseData[key]
            })
            message.error(result)
        }
    }, [status, responseData])

    const onFinish = (values) => {
        let data = {
            capacity: 0,
            isNew: !values.isNew,
            id: parcelId,
            applicationUserId: UserId,
            deviceTypeId: values.deviceType,
            carrierCompanyId: values.carrierCompany,
            useNewSIM: values.useNewSIM
        }
        if (values.capacity >  capacity -  remainingCapacity) {
            data = { ...data, capacity: values.capacity }
        } else data = { ...data }

        if (data.capacity > 0) {
            sendRequest({
                endpoint: EndPoints.PARCEL.PUTPARCEL,
                method: 'PUT',
                data
            }, 'PUTPARCEL', 'Η Ανανέωση του πακέτου ήταν επιτυχής')
        }
        if (data.capacity === 0) message.error('Επίλεξε σύνολο συσκευασιών κιβωτίου μεγαλύτερο του αριθμού που καταχωρήθηκαν')
    }
    const navigateToNewDeviceForm = () => {
        history.push('/choices/new-device')
    }

    return (
        <PackingForm
            loading={loading}
            form={form}
            onFinish={onFinish}
            responseData={responseData}
            deviceType={deviceType}
            carrierCompany={carrierCompany}
            isDisplayPackageId={false}
            submitButtonName="Καταχώρηση"
            isNewChecked={!isNew}
            isDisabledOBDType="true"
            isNewOnChangeValue={isNewOnChangeValue}
            handleIsNewChanged={handleIsNewChanged}
            navigateToNewDeviceForm={navigateToNewDeviceForm}
            isVisibleContinueButton={false}
            isVisibleUpdateButton="true"      
            isNewButtomDisabled = "true" 
            isCarrierCompanyDisabled="true" 
            isBarcodePrintDisabled="true"  
            isNewUseSIMDisable="true"
             deviceTypeId={ deviceTypeId}
        />
    );

}